module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-1ee6fba9.png";